module.exports = __webpack_public_path__ + "static/media/wand.6bba9add.svg";